<div class="app-shell app-shell--cr1 min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.18),transparent_32%),linear-gradient(180deg,rgba(15,23,42,0.96),rgba(2,6,23,1))] text-on-surface">
  <div class="grid min-h-screen w-full gap-4 px-3 py-3 sm:px-4 sm:py-4 lg:grid-cols-[13rem_minmax(0,1fr)] lg:px-4">
    <aside class="border border-white/10 bg-white/5 p-4 backdrop-blur lg:sticky lg:top-4 lg:h-[calc(100vh-2rem)]">
      <p class="text-xs uppercase tracking-[0.35em] text-white/60">Project Planning App</p>
      <button
        class="mt-4 inline-flex w-full items-center justify-center bg-cyan-300 px-3 py-2 text-xs font-semibold text-slate-950 transition hover:bg-cyan-200"
        type="button"
        (click)="openQuickCreateDialog()"
      >
        New Card
      </button>

      <nav class="mt-4 space-y-2" aria-label="Primary navigation">
        @for (item of navigationItems; track item.route) {
          <a
            [routerLink]="item.route"
            routerLinkActive="border-cyan-200 bg-cyan-300/15 text-cyan-100"
            class="block border border-white/10 bg-slate-950/30 px-3 py-2 transition hover:border-white/30 hover:text-white"
          >
            <span class="block text-xs font-semibold uppercase tracking-[0.2em]">{{ item.label }}</span>
            <span class="mt-1 block text-[11px] leading-4 opacity-70">{{ item.description }}</span>
          </a>
        }
      </nav>
    </aside>

    <main class="min-w-0 py-0">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

@if (showQuickCreateDialog()) {
  <app-quick-create-card-dialog (dismissed)="closeQuickCreateDialog()" />
}

<app-encryption-password-dialog />
